import { ContractConceptRelationshipState } from '../../states/ContractConceptRelationship.State';
import { ContractConceptRelationship } from '../../../models/Entities/Contracts/ContractConceptRelationship';
import * as actions from '../../actions/ContractConceptRelationship.Actions';

import { ContractConceptRelationshipUnloadState } from '../../states/ContractConceptRelationship.State';

export default function ContractConceptRelationshipDeleteReducer(
  state: ContractConceptRelationshipState | undefined,
  action: any
): ContractConceptRelationshipState {
  const currentState = state ?? ContractConceptRelationshipUnloadState;
  switch (action.type) {
    case actions.CONTRACT_CONCEPT_REL_DELETE_REQUEST:
      return {
        ...currentState,
        isDeletingOne: true,
        successDeletingOne: undefined,
        failOnDeletingOne: false,
        error: undefined,
      };
    case actions.CONTRACT_CONCEPT_REL_DELETE_SUCCESS:
      return {
        ...currentState,
        isDeletingOne: false,
        successDeletingOne: true,
        failOnDeletingOne: false,
        list: currentState.list.filter((item: ContractConceptRelationship) => item.id !== action.id),
      };
    case actions.CONTRACT_CONCEPT_REL_DELETE_FAILURE:
      return {
        ...currentState,
        isDeletingOne: false,
        successDeletingOne: false,
        failOnDeletingOne: true,
        error: action.error,
      };
    default:
      return currentState;
  }
}
